import { useQuery } from "react-query";

import { EvalIds } from "graphql/generated";
import { getEvaluationDataFromLocalStorage } from "src/utils/getEvaluationDataFromLocalStorage";

export const useGetEvaluationDataFromLocalStorageQuery = (evaluationId: EvalIds) =>
  useQuery(["localEvalData", evaluationId], () => getEvaluationDataFromLocalStorage(evaluationId));
